module.exports = __webpack_public_path__ + "img/close_icon.5eacf7ce.svg";